(() => {
  if (window.engravingPreviewLoaded) return;
  window.engravingPreviewLoaded = true;

  const CARD = '[data-engraving-preview]';
  const NAME = '[data-engraving-name]';
  const FONT = '.engraving-card__select';

  const buildLayer = (card) => {
    const layer = document.createElement('div');
    layer.className = `engraving-preview ${card.dataset.previewClass}`;
    layer.setAttribute('aria-hidden', 'true');
    const text = document.createElement('div');
    text.className = 'engraving-preview__text';
    layer.append(text);
    return layer;
  };

  const galleryImages = (card) =>
    [...document.getElementsByClassName(card.dataset.mediaClass)]
      .map((slide) => slide.querySelector('button'))
      .filter(Boolean);

  const paintLayer = (card, holder, name, family) => {
    let layer = holder.querySelector('.engraving-preview');
    if (!layer) {
      if (!name) return;
      layer = buildLayer(card);
      holder.append(layer);
    }
    const text = layer.firstElementChild;
    layer.hidden = !name;
    text.textContent = name;
    text.style.fontFamily = family;
  };

  const paint = (card) => {
    if (!card.isConnected) return;
    const select = card.querySelector(FONT);
    const name = card.querySelector(NAME).value.trim() || card.dataset.sample || '';
    const font = select.value || (select.options[1] && select.options[1].value) || '';
    const family = `'${font}', sans-serif`;
    const images = galleryImages(card);

    images.forEach((holder) => paintLayer(card, holder, name, family));

    const mini = card.querySelector('[data-engraving-mini]');
    if (!mini) return;
    mini.hidden = !name;
    const visible = images.find((holder) => holder.clientWidth > 0);
    if (visible && name) mini.style.aspectRatio = `${visible.clientWidth} / ${visible.clientHeight}`;
    paintLayer(card, mini, name, family);
  };

  const showPreviewImage = (card) => {
    const slider = document.getElementById(`x-product-${card.dataset.sectionId}`);
    if (!slider || !slider.splide) return;
    const slide = [...slider.getElementsByClassName(card.dataset.mediaClass)].find(
      (element) => !element.classList.contains('splide__slide--clone'),
    );
    if (!slide) return;
    const index = parseInt(slide.getAttribute('index'));
    if (slider.splide.index !== index) slider.splide.go(index);
  };

  const handleEdit = (event) => {
    const card = event.target.closest && event.target.closest(CARD);
    if (!card) return;
    const isName = event.target.matches(NAME);
    const isFont = event.target.matches(FONT);
    if (!isName && !isFont) return;

    const hasName = card.querySelector(NAME).value.trim() !== '';
    if (hasName) card.querySelector('.engraving-card__dropdown').dispatchEvent(new Event('focusin'));
    paint(card);
    if (hasName && (isFont || card.dataset.previewShown !== 'true')) showPreviewImage(card);
    card.dataset.previewShown = String(hasName);
  };

  const prepare = () => {
    document.querySelectorAll(CARD).forEach((card) => {
      paint(card);
      document.addEventListener(`eurus:media-gallery-ready:${card.dataset.sectionId}`, () => paint(card));
    });
  };

  document.addEventListener('input', handleEdit, true);
  document.addEventListener('change', handleEdit, true);
  document.addEventListener('shopify:section:load', prepare);
  prepare();
})();
